'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dataLayerPush = exports.pushTagData = exports.loadContainers = exports.isDataLayerLoaded = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _loadJS = require('./loadJS');

var _loadJS2 = _interopRequireDefault(_loadJS);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var isClientSide = typeof window !== 'undefined';
var isDataLayerLoaded = isClientSide && typeof window.dataLayer !== 'undefined';

var loadContainers = function loadContainers() {
  for (var _len = arguments.length, containerIds = Array(_len), _key = 0; _key < _len; _key++) {
    containerIds[_key] = arguments[_key];
  }

  if (isClientSide) {
    containerIds.forEach(function (containerId) {
      (0, _loadJS2.default)('' + containerId);
    });
  }
};

var pushData = function pushData() {
  var rawData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  window.dataLayer.push(_extends({}, rawData));
};

function Tracking() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  function trackData(rawData) {
    if (isDataLayerLoaded) {
      pushData(rawData);
      return true;
    }
    console.log('==> dataLayer Not Found!!!');
    return false;
  }
  if (props.containerIds) {
    loadContainers.apply(undefined, _toConsumableArray(props.containerIds));
  }
  return props.children({ trackData: trackData });
}

Tracking.propTypes = {
  env: _propTypes2.default.string.isRequired,
  platform: _propTypes2.default.string,
  containerIds: _propTypes2.default.array
};

var tagDataQueue = null;
var tagInterval = null;

function pushTagData(payload) {
  var dataLayerLoaded = typeof window !== 'undefined' && window.dataLayer;

  if (dataLayerLoaded) {
    // dataLayer loaded, almost cases dive into here
    window.dataLayer.push(payload);
  } else {
    // if dataLayer have not load done,
    // check if exist an interval (***), push payload in queue
    if (tagInterval) {
      if (Array.isArray(tagDataQueue)) {
        tagDataQueue.push(payload);
      }
    } else {
      // (***) interval check dataLayer load finish for push all payload in queue to GA
      var countInterval = 0;
      tagDataQueue = [payload];
      tagInterval = setInterval(function () {
        if (window.dataLayer) {
          clearInterval(tagInterval);
          tagInterval = null;
          tagDataQueue.forEach(window.dataLayer.push);
          tagDataQueue = null;
        } else if (++countInterval > 10) {
          // interval check about 10s
          clearInterval(tagInterval);
        }
      }, 1000);
    }
  }
}

function dataLayerPush(payload) {
  if (!!window.google_tag_manager) {
    // Google Tag Manager has already been loaded
    window.dataLayer.push(payload);
  } else {
    window.addEventListener('gtm_loaded', function () {
      // Google Tag Manager has been loaded
      window.dataLayer.push(payload);
    }, {
      once: true
    });
  }
}

exports.default = Tracking;
exports.isDataLayerLoaded = isDataLayerLoaded;
exports.loadContainers = loadContainers;
exports.pushTagData = pushTagData;
exports.dataLayerPush = dataLayerPush;